var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrapper md:w-full"},[_c('nav',{staticClass:"mx-auto flex flex-wrap relative mt-2"},[_c('ul',{staticClass:"flex flex-row justify-between items-center"},[_c('li',[_c('Navigation')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }